<script lang="ts">
	import VerivoxSetupBanner from './internal/VerivoxSetupBanner.svelte';
	import type { VerivoxDismissSurface } from '../utils/verivoxDismissals';

	/** Verivox setup promo for the dashboard BannersWidget gallery (~180px). */
	export let onCtaClick: () => void;
	export let dismissable = false;
	export let dismissSurface: VerivoxDismissSurface = 'energyDashboard';
	export let onDismiss: (() => void) | undefined;
</script>

<VerivoxSetupBanner
	layout="widget"
	{onCtaClick}
	{dismissable}
	{dismissSurface}
	{onDismiss}
/>
